import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import Home from "./pages/Home.jsx";
import Products from "./pages/Products.jsx";
import Portfolio from "./pages/Portfolio.jsx";
import RequestService from "./pages/RequestService.jsx";
import PayNow from "./pages/PayNow.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import Accessibility from "./pages/Accessibility.jsx";
import TermsOfService from "./pages/TermsOfService.jsx";
import RefundPolicy from "./pages/RefundPolicy.jsx";
import RequireRole from "./auth/RequireRole.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";


export default function App() {
    return (
        <div className="app-shell">
            <Header />
        <main className="container">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/request" element={<RequestService />} />
                <Route path="/paynow" element={<PayNow />} />
                <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                <Route path="/Accessibility" element={<Accessibility />} />
                <Route path="/TermsOfService" element={<TermsOfService />} />
                <Route path="/RefundPolicy" element={<RefundPolicy />} />

                {/* PROTECTED ROUTE (admin only) */}
                <Route path="/admin"element={<RequireRole role="admin">
                    <AdminDashboard /></RequireRole>}/>
            </Routes>
        </main>
            <Footer />
        </div>
    );
}